import { render, staticRenderFns } from "./HotSuList.vue?vue&type=template&id=c03356d2&scoped=true&"
import script from "./HotSuList.vue?vue&type=script&lang=js&"
export * from "./HotSuList.vue?vue&type=script&lang=js&"
import style0 from "./HotSuList.vue?vue&type=style&index=0&id=c03356d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c03356d2",
  null
  
)

export default component.exports